import { createContext, useContext } from "react";
import { AllFormFields, FormStateValues } from "./methodsAndHandlers";

interface IncidentFormContextType {
  viewModel: { [x: string]: boolean };
  isSubmitting: boolean;
  canUserEditPostSubmission: boolean;
  editPermission: boolean;
  canSubmitForm: boolean;
  shouldStayOnPage: boolean;
  openDeleteModal: boolean;
  showPrompt: boolean;
  shouldAllowInput: boolean;
  selectOptions?: any;
  rlViewModel?: any;
  setDeleteRLRecordObject?: any;
  formBasicDetails?: any;
  qaMode?: boolean;
  showConfirmationPrompt: boolean;
  tempValue: any;
  setSearchParams: (x: any) => void;
  hasUnsavedChanges: boolean;
  setShouldStayOnPage: (x: boolean) => void;
  navigateWithinForm: (x: string) => void;
  setOpenDeleteModal: (x: boolean) => void;
  setIsSubmitting: (x: boolean) => void;
  _handleDiscard: (x?: any) => void;
  setShowConfirmationPrompt: (x: boolean) => void;
  setTempValue: (x: any) => void;
  isLastStep: boolean;
  currentStageIndex: number;
  formStateValues: FormStateValues;
  allFormFields: AllFormFields;
  tabState: any;
  exitLink: string;
  shouldResetForm: boolean;
  markedAsHighSeverity: boolean;
  showHighSeverityModal: boolean;
  setShowHighSeverityModal: (x: boolean) => void;
  setHighSeverityAcknowledged: (x: boolean) => void;
  showEMRReminder: boolean;
  setShowEMRReminder: (x: boolean) => void;
  handleEMRAcknowledgement: () => void;
}

const IncidentContext = createContext<IncidentFormContextType>({
  viewModel: {},
  isSubmitting: false,
  canUserEditPostSubmission: false,
  editPermission: false,
  canSubmitForm: false,
  shouldStayOnPage: false,
  openDeleteModal: false,
  showPrompt: false,
  shouldAllowInput: false,
  isLastStep: false,
  currentStageIndex: 0,
  hasUnsavedChanges: false,
  showConfirmationPrompt: false,
  tempValue: null,
  setSearchParams: (value: any) => {},
  setShouldStayOnPage: (x: boolean) => {},
  setDeleteRLRecordObject: (x: any) => {},
  setIsSubmitting: (x: boolean) => {},
  setOpenDeleteModal: (x: boolean) => {},
  setShowConfirmationPrompt: (x: boolean) => {},
  setTempValue: (x: boolean) => {},
  _handleDiscard: () => {},
  formStateValues: {
    guestName: "",
    ssnLastFourDigits: "",
    agency: "",
    shiftWorked: "",
    unitAssignment: "",
    incidentTypeFlag: "",
    userId: "",
    userName: "",
    incidentCreatedBy: undefined,
    initialValues: undefined,
    deleteRelatedRecords: [],
    markedAsHighSeverity: false,
  },
  allFormFields: {
    allFields: [],
    incidentRelatedLists: undefined,
  },
  tabState: undefined,
  navigateWithinForm: () => {},
  exitLink: "",
  shouldResetForm: false,
  markedAsHighSeverity: false,
  showHighSeverityModal: false,
  setShowHighSeverityModal: (x: boolean) => {},
  setHighSeverityAcknowledged: (x: boolean) => {},
  showEMRReminder: false,
  setShowEMRReminder: (x: boolean) => {},
  handleEMRAcknowledgement: () => {},
});
export const useIncidentFormContext = (): IncidentFormContextType => {
  return useContext(IncidentContext);
};
export const IncidentContextProvider = IncidentContext.Provider;
export default IncidentContext;
